<template>
  <qx-card title="充值记录">
    <LogRightDialog ref="logRightDialog" busiCode="230001" />
    <RechargeAudit ref="rechargeAudit" @success="rechargeAuditSuccess" />
    <section slot="titleRight">
      <qx-permpisions :permpisions=" this.$route.path.includes('gasCard')?'1005050401':'1005030601'">
        <el-button
          type="primary"
          plain
          @click="() => writeOff(tableData.selectResult)"
          >批量核销</el-button
        >
      </qx-permpisions>
      <qx-permpisions :permpisions=" this.$route.path.includes('gasCard')?'1005050404':'1005030604'">
        <ExportBtn
          :len="tableData.data.length"
          queryUrl="manualPaymentBO.ajax?cmd=getOilEntitys"
          :params="fullSearchData"
          :bizName="this.$route.path.includes('gasCard')?'气卡充值数据导出':'油卡充值数据导出'"
          bizCode="exp100071"
          :excelKeys="excelKeys"
          :excelLables="excelLables"
        />
      </qx-permpisions>

      <qx-permpisions permpisions>
        <TableSetting v-model="tableData.title" />
      </qx-permpisions>
    </section>
    <section class="tablePage">
      <!-- 表格 -->
      <section class="tableBox" ref="tableBox">
        <el-table
          v-loading="tableData.loading"
          ref="multipleTable"
          :data="tableData.data"
          tooltip-effect="dark"
          :height="tableHeight"
          @select="handleSelectionChange"
          @select-all="handleSelectionChange"
        >
          <!-- 选择框 -->
          <el-table-column type="selection" width="55" :selectable="checkSelectable" />
          <!-- 选择框 end -->
          <!-- 常规列表项 -->
          <template v-for="(item, index, key) in tableData.title">
            <el-table-column
              :key="key"
              :prop="item.prop"
              :label="item.label"
              :sortable="item.sortable"
              :filters="item.filters"
              :filter-method="item.filterHandler"
              :min-width="item.minW"
              :width="item.w"
              :fixed="item.fixed"
              v-if="item.show"
            >
              <section slot-scope="scope">
                <section v-if="scope.column.property === 'isParent'">
                  <span v-if="scope.row.isParent === 1">主卡充值</span>
                  <span v-else-if="scope.row.isParent === 0">子卡充值</span>
                  <span v-else>--</span>
                </section>
                <section v-else-if="scope.column.property === 'rechargeState'">
                  <span v-if="scope.row.rechargeState === 1">未充值待发起</span>
                  <span v-else-if="scope.row.rechargeState === 2"
                    >待付款(平台服务商卡)</span
                  >
                  <span v-else-if="scope.row.rechargeState === 3"
                    >已付款(平台服务商卡)</span
                  >
                  <span v-else-if="scope.row.rechargeState === 4"
                    >服务商已充值(平台服务商卡)</span
                  >
                  <span v-else-if="scope.row.rechargeState === 5">已充值</span>
                  <span v-else>--</span>
                </section>
                <section
                  v-else-if="scope.column.property === 'verificationDate'"
                >
                  <span>{{
                    scope.row.verificationDate
                      ? formatDate(scope.row.verificationDate)
                      : ''
                  }}</span>
                </section>
                <section v-else-if="scope.column.property === 'orderId'">
                  <span
                    v-if="scope.row.orderId"
                    class="primary cur"
                    @click="toOrderDetail(scope.row)"
                    >{{ scope.row.orderId }}</span
                  >
                  <span v-else>--</span>
                </section>
                <section v-else-if="scope.column.property === 'plateNumber'">
                  <span
                    v-if="scope.row.plateNumber"
                    class="primary cur"
                    @click="toCarDetail(scope.row)"
                    >{{ scope.row[scope.column.property] }}</span
                  >
                  <span v-else>--</span>
                </section>
<!--                <section v-else-if="scope.column.property==='oilCardTypeName'">
                  <span v-if="scope.row.oilCardType===6 && scope.row.cardTypeRemark">{{scope.row.cardTypeRemark}}</span>
                  <span v-else>{{scope.row.oilCardTypeName}}</span>
                </section>-->
                <section v-else>{{ scope.row[scope.column.property] }}</section>
              </section>
            </el-table-column>
          </template>
          <!-- 常规列表项 end -->
          <!-- 操作按钮 -->
          <el-table-column
            prop="control"
            label="操作"
            width="140"
            fixed="right"
          >
            <template slot-scope="scope">
              <TableBtn
                :tableData="scope.row"
                :btnList="[
                //  {
                //    showCondition: scope.row.rechargeState === 1,
                //    name: '审核',
                //    event: () => toVerify(scope.row),
                //  },
                  {
                    permpisions: $route.path.includes('gasCard')?'1005050403':'1005030603',
                    showCondition:
                      (scope.row.lineState === 1 &&
                        scope.row.rechargeState === 2 &&
                        scope.row.oilType == 2) ||
                      (scope.row.lineState === 0 &&
                        scope.row.verificationState === 1 &&
                        scope.row.oilType === 2 &&
                        scope.row.rechargeState !== 6),
                    name: '撤销',
                    event: () => toRevoke(scope.row),
                  },
                  {
                    permpisions:  $route.path.includes('gasCard')?'1005050402':'1005030602',
                    showCondition:
                      scope.row.rechargeState !== 6 &&
                      scope.row.verificationState === 1,
                    name: '核销',
                    event: () => writeOff([scope.row]),
                  },
                  {
                    showCondition: true,
                    name: '日志',
                    event: () => showLog(scope.row.id),
                  },
                ]"
              />
            </template>
          </el-table-column>
          <!-- 操按钮 end -->
        </el-table>
      </section>
      <!-- 表格 end -->
      <!-- 分页 -->
      <section class="paginationBox clearPa">
        <!-- 分页组件 -->
        <section class="right">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="tableData.page"
            :page-sizes="[10, 20, 50]"
            :page-size="tableData.count"
            layout="total, sizes, prev, pager, next, jumper"
            :total="tableData.total"
          ></el-pagination>
        </section>
        <!-- 分页组件 end -->
      </section>
      <!-- 分页 end -->
    </section>
  </qx-card>
</template>

<script>
import tableMixin from '@qx/mixin/table';
import LogRightDialog from 'components/logRightDialog';
import ExportBtn from 'components/exportBtn';
import TableBtn from 'components/tableBtn/tableBtn';
import RechargeAudit from './rechargeAudit';
import TableSetting from 'components/tableSetting/tableSetting';
import {
  oilRechargeList,
  oilRechargeWriteOff,
  oilRechargeCancel,
} from 'api/service';
export default {
  mixins: [
    tableMixin,
  ],
  components: {
    LogRightDialog,
    ExportBtn,
    TableBtn,
    RechargeAudit,
    TableSetting,
  },
  data () {
    return {
      tableData: { // 表格相关数据
        loading: false,
        count: 10,
        page: 1,
        total: 0,
        selectResult: [], // 表格选中的结果
        title: [ // 表头
          { label: '主卡卡号', prop: 'parentOilCarNum', fixed: true },
          { label: '子卡卡号', prop: 'oilCarNum' },
          { label: '充值类型', prop: 'topUpType' },
          { label: '油卡来源', prop: 'cardTypeName' },
          { label: '油卡类型', prop: 'oilCardTypeName' },
          { label: '充值金额（元）', prop: 'preOilFeeDouble' },
          { label: '申请时间', prop: 'creationTimeStr' },
          { label: '充值状态', prop: 'rechargeStateName' },
          { label: '核销时间', prop: 'verificationDate' },
          { label: '账单号', prop: 'billNo' },
          { label: '订单号', prop: 'orderId' },
          { label: '车牌号码', prop: 'plateNumber' },
          { label: '司机姓名', prop: 'carDriverMan' },
          { label: '司机手机', prop: 'carDriverPhone' },
          { label: '车辆种类', prop: 'vehicleClassName' },
          { label: '发车时间', prop: 'dependTimeStr' },
          { label: '客户名称', prop: 'customName' },
          { label: '线路名称', prop: 'sourceName' },
        ],
        data: [ // 表格内容
        ],
      },
    };
  },
  methods: {
    getList: oilRechargeList,
    rechargeAuditSuccess () {
      this.getData();
    },
    toCarDetail (item) {
      this.jump({
        label: `查看车辆${item.plateNumber ? ('-' + item.plateNumber) : ''}`,
        url: `/manage/car/archives/my/detailRecord?plateNumber=${encodeURIComponent(item.plateNumber)}`,
        full: true,
      });
    },
    toOrderDetail (item) {
      this.jump({
        label: `订单详情-${item.orderId}`,
        url: `/manage/operate/order/deal/orderDetailTab?id=${item.orderId}`,
        full: true,
      });
    },
    showLog (customerId) {
      this.$refs.logRightDialog.show(customerId);
    },
    toVerify (item) {
      this.$refs.rechargeAudit.show(item);
    },
    async toRevoke (item) {
      const confirmRes = await this.$confirm('是否要进行撤销操作？', '温馨提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).catch(() => { // 取消删除
      });
      if (confirmRes === 'confirm') {
        const res = await oilRechargeCancel({
          id: item.id,
          cardCategory: this.$route.path.includes('gasCard') ? 2 : 1,
        });
        if (!res.failed) {
          this.$message.success('撤销成功');
          this.getData();
        }
      }
    },
    async writeOff (arr) { // 核销
      if (arr.length === 0) {
        this.$message.warning('请先选择核销对象');
        return;
      }
      const confirmRes = await this.$confirm('是否确定要进行核销操作？', '温馨提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).catch(() => { // 取消删除
      });
      if (confirmRes === 'confirm') {
        const orderIds = arr.map((item) => item.id);
        const res = await oilRechargeWriteOff({
          orderIds: orderIds.join(','),
          cardCategory: this.$route.path.includes('gasCard') ? 2 : 1,
        });
        if (!res.failed) {
          this.tableData.selectResult = [];
          this.$message.success('核销成功');
          this.getData();
        }
      }
    },
    checkSelectable (row) {
      return row.rechargeState !== 5; // 状态为 2 禁用复选框（返回值为 true 启用，false 禁用）
    },
  },
  created () {
    if (this.$route.path.includes('gasCard')) {
      let Index;
      this.tableData.title.forEach((item, index) => {
        if (item.label.includes('油卡')) {
          item.label = item.label.replace(/油卡/g, '气卡');
        }
        if (item.prop === 'oilCardTypeName') {
          Index = index;
        }
      });
      this.tableData.title.splice(Index + 1, 0, { prop: 'cardTypeRemark', label: '类型备注' },);
    }
  },
};
</script>

<style lang="scss" scoped>
.control {
  span {
    margin-right: 16px;
  }
}
</style>
